import styled from "styled-components";
import theme from "../../Styles/theme";

export const Help = styled.div`

  

`;

export const Container = styled.div`
 display: flex;
    align-items:center;
    justify-content:center;

`;


export const Titulo = styled.h3`
    color:${theme.colors.dark}
`;